import type { AmountTone } from './getOperationTypeAmountSign';

export type AmountToneStatus = 'success' | 'danger' | 'neutral';

const AMOUNT_TONE_STATUS: Record<AmountTone, AmountToneStatus> = {
  positive: 'success',
  negative: 'danger',
  neutral: 'neutral',
};

export const getAmountToneStatus = (tone: AmountTone): AmountToneStatus =>
  AMOUNT_TONE_STATUS[tone];
